module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page_title":"Blog"},"ja":{"page_title":"ブログ"}}')
  delete Component.options._Ctor
}
